import { useMemo } from "react";

import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import { misc } from "app/themes/colors";

type DisplayCptCodesItemProps = {
  cptCodes: (string | undefined)[] | undefined;
  highlightCptCodes?: string[];
};
export default function DisplayCptCodesItem({
  cptCodes,
  highlightCptCodes
}: DisplayCptCodesItemProps) {
  const cptCodesSet = useMemo(
    () => new Set(highlightCptCodes),
    [highlightCptCodes]
  );
  if (!cptCodes?.length) return null;

  return (
    <ListItemText
      sx={{
        whiteSpace: "pre-line",
        pr: 2
      }}
      primary={
        <Typography sx={{ color: grey[600], mb: 0.75 }}>CPT codes:</Typography>
      }
      secondary={
        <Typography
          sx={{
            lineHeight: 1.3
          }}
        >
          {cptCodes.map((code) => (
            <Typography
              key={code}
              sx={{
                backgroundColor:
                  code && cptCodesSet.has(code) ? misc.warningYellow : undefined
              }}
            >
              {code}
            </Typography>
          ))}
        </Typography>
      }
    />
  );
}
